
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/safety",
      function () {
        return require("private-next-pages/safety.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/safety"])
      });
    }
  